import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Observable } from 'rxjs/internal/Observable';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return fetchAuthSession({ forceRefresh: true })
      .then((session) => {
        const groups = session.tokens?.accessToken?.payload['cognito:groups'] as string[] | undefined;
        this.auth.groups = groups || [];
        return true;
      })
      .catch(() => {
        this.router.navigate(['/auth']);
        return false;
      });
  }
}
